import classes from './notFound.module.css';

const NotFound = () => {
    return (
        <div className={classes["container"]}>
           <h2 className="centered-text">Error:404 Page Not Found!</h2> 
        </div>
    )
}

export default NotFound
